<div [ngClass]="{'pre-white': pageType=='All','pre-white-modal':pageType!=='All'}" [dir]="textDir">
  <div *ngIf="pageType=='All'">
    <label class="form-title">3. {{'Add students & teachers' | translate}}</label>
    <label class="label-light">{{this.school_name}}</label>
</div>
<div  class="top-header-sm" *ngIf="pageType!=='All'">
  <label class="form-title" *ngIf="pageType=='StudentOnly'">{{'Add multiple students' | translate}}</label>
  <label class="form-title" *ngIf="pageType=='TeacherOnly'">{{'Add multiple teachers' | translate}}</label>

</div>
    <div *ngIf="pageType=='All'">
      <label *ngIf="!nextBtnClicked" class="labeltxt marT15">{{'In this step, you will add your students and teachers to the system.' | translate}}</label>
<!--       <label *ngIf="nextBtnClicked" class="labeltxt marT15">Is this correct? Select Confirm, or Edit to upload a new excel file.</label>
 -->    </div>
      <!--  <p class="import-text" style="padding-left: 20px;" *ngIf="!nextBtnClicked"><strong>Import Excel File</strong></p>
    <p class="import-text" style="padding-left: 20px;" *ngIf="nextBtnClicked"><strong>Verify Excel File</strong></p> -->
    
    <div [ngClass]="{'min-hight-360 grey-M no-pad':pageType=='All','min-hight-220 grey-M pad20':pageType!=='All'}">
      <form id="wazard" class="grey-M no-pad form-inline" >
        <!-- <p style="margin-left: 47px;padding-top: 30px;" *ngIf="pageType == 'All'">Upload your excel sheet, correctly formatted according to this <a style="cursor: pointer;" (click)='downloadTemplate()'>template</a>.</p> -->
        
        <label class="labeltxt" *ngIf="!nextBtnClicked && pageType=='StudentOnly'" >{{'Please ensure all student details are correctly formatted into this' | translate}} <a style="cursor: pointer;" class="dot-link-txt" (click)='downloadTemplate()'>{{'excel template' | translate}}</a>.</label>
        <label class="labeltxt" *ngIf="!nextBtnClicked && pageType=='TeacherOnly'" >{{'Please ensure all teacher details are correctly formatted into this' | translate}} <a style="cursor: pointer;" class="dot-link-txt" (click)='downloadTemplate()'>{{'excel template' | translate}}</a>.</label>
        <label class="labeltxt" *ngIf="!nextBtnClicked && pageType=='All'" [ngClass]="pageType=='All'?'marT15':''">{{'Please ensure all student and teacher details are correctly formatted into this' | translate}} <a style="cursor: pointer;" class="dot-link-txt" (click)='downloadTemplate()'>{{'excel template' | translate}}</a>.</label>
        <label class="labeltxt marT15" *ngIf="!nextBtnClicked">{{'When ready, select your excel file from your computer, then select Verify.' | translate}}</label>
        
        <label class="labeltxt marT15"  *ngIf="nextBtnClicked">{{'Please verify the data summary' | translate}} {{'If incorrect select Edit' | translate}}</label>
  
        <!-- <div align="center" style="left: 0px;margin-top:50px;margin-bottom: 30px;" *ngIf="pageType == 'All'"><img src="assets/images/add-group_w.png" alt=""></div> -->
  
        <ng-container *ngIf="nextBtnClicked && (xlsStudentCount || xlsTeacherCount || xlsClassCount)">
         <div class="marT20 marB10"><label class="label-light">{{'Data summary' | translate}}</label></div>
          <div class="excelDetailsWizard marB10">
              <label align="left" class="labeltxt"><i class="icon icon-alarm-level1"></i>{{xlsStudentCount}} {{'Students' | translate}} in {{xlsClassCount}} {{'Classes' | translate}}</label>
              <label align="left" class="labeltxt"><i class="icon icon-alarm-level1"></i>{{xlsTeacherCount}} {{'Teachers' | translate}}</label>
            </div>
            <div class="marT20 marB10"><label class="label-light">{{'Data samples' | translate}}</label></div>
          <div class="excelDetailsWizard marB10">            
            <label align="left" class="labeltxt"><a (click)="dataSampleLink()">{{'View student and teacher data samples' | translate}}</a></label> 
          </div>
        </ng-container>
        <ng-container *ngIf="!nextBtnClicked">
        <div class="marT30" [ngClass]="{'setup-import marT30': pageType=='All','modal-import marT20':pageType!=='All'}" *ngIf="loadingPage==false" id="dropzone" class="dropzone" ngFileDrop [options]="options" (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput">
          <div class="area">
            <ng-container *ngIf="xlsFile">
              <label class="eds-link font12">{{xlsFile}}</label>
            </ng-container>
            <ng-container *ngIf="!xlsFile">
              <span class="btn btn-link ctlInputFile">
                <input id="ctlFileID" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" name="file-upload" ngFileSelect [options]="options " (uploadOutput)="onUploadOutput($event) " [uploadInput]="uploadInput">
                <span class="glyphicon glyphicon-open marR10"></span> {{'Select your excel file' | translate}} &nbsp;&nbsp;&nbsp;&nbsp;<i class="icon icon-upload"></i></span>
              
            </ng-container>
  
          </div>
          <div class="upload-items">
            <div class="upload-item" *ngFor="let f of files; let i = index;">
              <span class="filename">
                <span>{{ f.name }} ({{ f.id }}) - {{ f.progress?.data?.percentage }}%</span>
                <span>uploading with {{ f.progress?.data?.speedHuman }}</span>
                <span>ETA {{ f.progress?.data?.etaHuman }}</span>
              </span>
              <div class="progress">
                <span class="bar" [style.width]="f?.progress?.data?.percentage + '%'"></span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="remove-link flexStart marT15" *ngIf="!nextBtnClicked"><label *ngIf="!nextBtnClicked && xlsFile"><a class="dot-link-txt" (click)="resetXlsFile()">{{'Remove file' | translate}}</a></label></div>
     
    <div class="div-hgt" *ngIf="!nextBtnClicked">

    </div>
  </form>
 </div>
  </div>
  
  
<!-- Error modal for check and import -->
<lib-modalform *ngIf="this.pageType !== 'TeacherOnly'"
  modalClass="errorModal1"
  modalID="errorModal1"
  [viewType]="'add'"
  [modalTitle]="titleMessage"
  [btnCancelText]="'Ok'">
  <!-- (cancelEvent)="cancelImport('')"> -->
  <div class="modalBody errorModalWidth">
      <div class="padLR20 padT20 flexStart">
        <div class="" [ngClass]="textDir=='ltr'?'marR15':'marL15'">
            <img src="assets/images/error3x.png" width=29 height=29 alt="">
        </div>
        <div> 
          <label class="form-title"> {{this.titleMessage}}</label>
        </div>
      </div>
      
      <div class="pad65 padR20 padB20 dialog-body-txt" [dir]="textDir">
          <label>{{this.detailMessage1}}</label>
      </div>
  </div>
</lib-modalform>
<lib-modalform *ngIf="this.pageType === 'TeacherOnly'"
  modalClass="errorModal2"
  modalID="errorModal2"
  [viewType]="'add'"
  [modalTitle]="titleMessage"
  [btnCancelText]="'Ok'">
  <!-- (cancelEvent)="cancelImport('')"> -->
  <div class="modalBody errorModalWidth">
      <div class="padLR20 padT20 flexStart">
        <div class="" [ngClass]="textDir=='ltr'?'marR15':'marL15'">
            <img src="assets/images/error3x.png" width=29 height=29 alt="">
        </div>
        <div> 
          <label class="form-title"> {{this.titleMessage}}</label>
        </div>
      </div>
      
      <div class="pad65 padR20 padB20 dialog-body-txt" [dir]="textDir">
          <label>{{this.detailMessage1}}</label>
      </div>
  </div>
</lib-modalform>
<!-- END Error modal for check and import -->